import React from 'react';
import CalculatorInput from '@components/Calculators/CalculatorInput';
import ResultMessage from '@components/Calculators/ResultMessage';
import { getNumberAsCurrency, formatSuffix } from '@helpers/miscelleanous';
import CalculatedResults from '@components/Calculators/fd/CalculatedResults';
import useWindowDimensions from '@hooks/useWindowDimensions';

const CalculatorContainer = ({ states, callbacks, handleOnClick, disclaimer = null }) => {
    const { fields, calculatedValue } = states;
    const { onChangeCalculatorInput, onBlur } = callbacks;
    const { width } = useWindowDimensions();

    return (
        <>
            <div className="p-4 xl:p-[56px] border border-gray-300 rounded-2xl flex gap-8 flex-col">
                <div className="flex flex-col xl:flex-row gap-8 xl:gap-14 items-center xl:items-start">
                    <div className="flex flex-col gap-8 xl:gap-[50px] flex-1 w-full">
                        {Object.entries(fields).map(([key, field]) => {
                            return (
                                <React.Fragment key={key}>
                                    <CalculatorInput
                                        id={key}
                                        field={field}
                                        onChangeCalculatorInput={
                                            onChangeCalculatorInput
                                        }
                                        onBlur={onBlur}
                                    />
                                </React.Fragment>
                            );
                        })}
                    </div>
                    <div className="w-full md:w-[297px]">
                        <CalculatedResults calculatedValue={calculatedValue} disclaimer={disclaimer} />
                    </div>
                </div>
                <ResultMessage
                    primaryMessage={`Your corpus after ${
                        formatSuffix(fields.timePeriod.value, fields.timePeriod.suffix, fields.timePeriod.suffixSingular)
                    } will be <span class='h4-semibold text-primary-500 hidden md:inline-block'>${getNumberAsCurrency(
                        Math.round(calculatedValue.totalAmount)
                    )}</span>`}
                    amount={getNumberAsCurrency(
                        Math.round(calculatedValue.totalAmount)
                    )}
                    secondaryMessage={`with an investment of ${getNumberAsCurrency(
                        fields.totalInvestment.value
                    )} at ${fields.expectedRateOfReturn.value}% rate of return`}
                    isProductPage={width < 1280 ? false : true}
                    buttonText={'Book FD Now'}
                    handleOnClick={handleOnClick}
                />
            </div>
        </>
    );
};

export default CalculatorContainer;
